export default {"src":"/_next/static/media/ice-cream-fail.colour.015f2877.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};